import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/home/benning/Desktop/unchai-restaurant/node_modules/next/dist/client/app-dir/link.js");
